// @ts-nocheck
import * as Types from "../../../../types/types-v2.generated";

import { gql } from "@apollo/client";
import {
  TempFileCreatedViewServerFragmentDoc,
  CheckpointStartingViewServerFragmentDoc,
} from "./LogAnalysisView.v2.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type CheckpointStartingV2QueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  from?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  to?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
}>;

export type CheckpointStartingV2Query = {
  __typename?: "RootQuery";
  server: {
    __typename?: "Server";
    id: string;
    logAnalysis: {
      __typename?: "LogAnalysis";
      checkpointStarting: Array<{
        __typename?: "CheckpointStartingStat";
        bucketStart: string;
        reason?: string | null;
        count: number;
      }>;
    };
    postgresConfig: {
      __typename?: "PostgresConfig";
      settings: Array<{
        __typename?: "Setting";
        name: string;
        value?: string | null;
      }>;
    };
  };
};

export type TempFileCreatedV2QueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
  from?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  to?: Types.InputMaybe<Types.Scalars["Timestamp"]["input"]>;
  databaseId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type TempFileCreatedV2Query = {
  __typename?: "RootQuery";
  server: {
    __typename?: "Server";
    id: string;
    logAnalysis: {
      __typename?: "LogAnalysis";
      tempFileCreated: Array<{
        __typename?: "TempFileCreatedStat";
        bucketStart: string;
        count: number;
        avgSizeBytes?: number | null;
        query?: {
          __typename?: "Query";
          id: string;
          databaseId: string;
          displaySql: string;
        } | null;
      }>;
    };
    postgresConfig: {
      __typename?: "PostgresConfig";
      settings: Array<{
        __typename?: "Setting";
        name: string;
        value?: string | null;
      }>;
    };
  };
};

export const CheckpointStartingV2Document = gql`
  query CheckpointStartingV2($serverId: ID!, $from: Timestamp, $to: Timestamp) {
    server(id: $serverId) {
      id
      ...CheckpointStartingViewServer
    }
  }
  ${CheckpointStartingViewServerFragmentDoc}
`;

/**
 * __useCheckpointStartingV2Query__
 *
 * To run a query within a React component, call `useCheckpointStartingV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCheckpointStartingV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckpointStartingV2Query({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCheckpointStartingV2Query(
  baseOptions: Apollo.QueryHookOptions<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  > &
    (
      | { variables: CheckpointStartingV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  >(CheckpointStartingV2Document, options);
}
export function useCheckpointStartingV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  >(CheckpointStartingV2Document, options);
}
// @ts-ignore
export function useCheckpointStartingV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  CheckpointStartingV2Query,
  CheckpointStartingV2QueryVariables
>;
export function useCheckpointStartingV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckpointStartingV2Query,
        CheckpointStartingV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  CheckpointStartingV2Query | undefined,
  CheckpointStartingV2QueryVariables
>;
export function useCheckpointStartingV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        CheckpointStartingV2Query,
        CheckpointStartingV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CheckpointStartingV2Query,
    CheckpointStartingV2QueryVariables
  >(CheckpointStartingV2Document, options);
}
export type CheckpointStartingV2QueryHookResult = ReturnType<
  typeof useCheckpointStartingV2Query
>;
export type CheckpointStartingV2LazyQueryHookResult = ReturnType<
  typeof useCheckpointStartingV2LazyQuery
>;
export type CheckpointStartingV2SuspenseQueryHookResult = ReturnType<
  typeof useCheckpointStartingV2SuspenseQuery
>;
export type CheckpointStartingV2QueryResult = Apollo.QueryResult<
  CheckpointStartingV2Query,
  CheckpointStartingV2QueryVariables
>;
export const TempFileCreatedV2Document = gql`
  query TempFileCreatedV2(
    $serverId: ID!
    $from: Timestamp
    $to: Timestamp
    $databaseId: ID
  ) {
    server(id: $serverId) {
      id
      ...TempFileCreatedViewServer
    }
  }
  ${TempFileCreatedViewServerFragmentDoc}
`;

/**
 * __useTempFileCreatedV2Query__
 *
 * To run a query within a React component, call `useTempFileCreatedV2Query` and pass it any options that fit your needs.
 * When your component renders, `useTempFileCreatedV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTempFileCreatedV2Query({
 *   variables: {
 *      serverId: // value for 'serverId'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      databaseId: // value for 'databaseId'
 *   },
 * });
 */
export function useTempFileCreatedV2Query(
  baseOptions: Apollo.QueryHookOptions<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  > &
    (
      | { variables: TempFileCreatedV2QueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  >(TempFileCreatedV2Document, options);
}
export function useTempFileCreatedV2LazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  >(TempFileCreatedV2Document, options);
}
// @ts-ignore
export function useTempFileCreatedV2SuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  TempFileCreatedV2Query,
  TempFileCreatedV2QueryVariables
>;
export function useTempFileCreatedV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TempFileCreatedV2Query,
        TempFileCreatedV2QueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  TempFileCreatedV2Query | undefined,
  TempFileCreatedV2QueryVariables
>;
export function useTempFileCreatedV2SuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        TempFileCreatedV2Query,
        TempFileCreatedV2QueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    TempFileCreatedV2Query,
    TempFileCreatedV2QueryVariables
  >(TempFileCreatedV2Document, options);
}
export type TempFileCreatedV2QueryHookResult = ReturnType<
  typeof useTempFileCreatedV2Query
>;
export type TempFileCreatedV2LazyQueryHookResult = ReturnType<
  typeof useTempFileCreatedV2LazyQuery
>;
export type TempFileCreatedV2SuspenseQueryHookResult = ReturnType<
  typeof useTempFileCreatedV2SuspenseQuery
>;
export type TempFileCreatedV2QueryResult = Apollo.QueryResult<
  TempFileCreatedV2Query,
  TempFileCreatedV2QueryVariables
>;
